import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { useLocation, Link } from "react-router-dom";
import { getItemMenu, getMaestros } from "../../assets/js/api";
import { translate } from "../../assets/js/functions";

export default function Buscador({ section_id }) {
    const location = useLocation();
    const [maestros, setMaestros] = useState(null);
    const [item, setItem] = useState(location.state?.item || null);
    const [selectedLetter, setSelectedLetter] = useState("A");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);


    useEffect(() => {
        if (selectedLetter) {
            getMaestros(selectedLetter).then((data) => {
                setMaestros(data);
            });
        } else if (searchTerm) {
            searchByKeyword(searchTerm);
        } else {
            getMaestros("A").then((data) => setMaestros(data));
        }
    }, [selectedLetter, searchTerm]);

    const createTitle = (title) => {
        const words = title.split(" ");
        if (words.length < 3) return title;

        const result = [];
        for (let i = 0; i < words.length - 3; i++) {
            result.push(words[i], " ");
        }

        result.push(
            <span key="last-3-words-1" className="has-text-primary">{words[words.length - 3]}</span>,
            " ",
            <span key="last-3-words-2" className="has-text-primary">{words[words.length - 2]}</span>,
            " ",
            <span key="last-3-words-3" className="has-text-primary">{words[words.length - 1]}</span>
        );

        return <>{result}</>;
    };

    const handleLetterClick = (event, letter) => {
        event.preventDefault();
        setSelectedLetter(letter);
        setSearchTerm("");
    };

    const searchByKeyword = (keyword) => {
        getMaestros(null, keyword).then((data) => setMaestros(data));
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setSelectedLetter(null);
    };

    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header></Header>
                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--xl">
                        <h1 className="has-text-centered">{item ? createTitle(item.term) : ""}</h1>
                        <div className="columns is-centered">
                            <div className="column is-6-desktop">
                                <form action="#" className="search-form" onSubmit={(e) => e.preventDefault()}>
                                    <fieldset>
                                        <legend className="is-sr-only">Buscador</legend>
                                        <label htmlFor="buscar" className="is-sr-only">Buscar</label>
                                        <input
                                            type="search"
                                            id="buscar"
                                            className="is-size-6"
                                            value={searchTerm}
                                            placeholder={translate("Escribe el nombre y/o apellido de un maestro o maestra")}
                                            onChange={handleSearchChange}
                                        />
                                    </fieldset>
                                </form>
                            </div>
                        </div>

                        <nav aria-label="Índice alfabético">
                            <ol className="abc-list is-flex is-flex-wrap-wrap is-justify-content-center gap-2">
                                {alphabet.map((letter) => (
                                    <li key={letter}>
                                        <a
                                            href="#"
                                            className={selectedLetter === letter ? 'abc-list__active' : ''}
                                            onClick={(event) => handleLetterClick(event, letter)}
                                        >
                                            {letter}
                                        </a>
                                    </li>
                                ))}
                            </ol>
                        </nav>

                        <ul className="noms-list text-columns link-dn">
                            {maestros && maestros.length > 0 ? (
                                maestros.map((maestro) => (
                                    <li key={"maestro_" + maestro.section_id}>
                                        <Link to={`/buscador/ficha/${maestro.section_id}`}>
                                            {maestro.ref_victim_surname}, {maestro.ref_victim_name}
                                        </Link>
                                    </li>
                                ))
                            ) : ''}
                        </ul>
                    </div>
                </main>


                <Footer></Footer>
            </div>
        </Layout>
    );
}